import React from "react";
import {useRoutes} from "hookrouter";
import Registration from "./Registration/RegistrationAmateur";

export default () => useRoutes(subRoutes);

const subRoutes = {
  "/:id/registration": ({id}) => <Registration id={id}/>
};